import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';
import { BaseProvider } from 'baseui';
import { qnareadTheme } from './theme/qnareadTheme';
import './index.css';
import App from './App';
import { initAnalytics } from './utils/initAnalytics';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
const engine = new Styletron();

root.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={qnareadTheme}>
        <App />
    </BaseProvider>
  </StyletronProvider>
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch(() => {});
  });
}
